import React from "react";
import Logo from "../../assets/img/logo_with_years.png";
import {Link} from "react-router-dom";
import {FrontendRoutes} from "../../constants";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
  logoContainer: {
    fontSize: 14,
    color: '#bea06b',
    marginTop: props => props.width * 0.1
  },
})

const AppLogo = (props) => {
  const [width, setWidth] = React.useState(window.innerWidth > 900 ? window.innerWidth * 0.1: window.innerWidth * 0.1);

  const classes = useStyles({width})

  React.useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 900) {
        setWidth(window.innerWidth * 0.1)
      } else {
        setWidth(window.innerWidth * 0.1)
      }
    }
    window.addEventListener('resize', handleResize)
  })

  return (
    <div className={classes.logoContainer}>
      <Link to={FrontendRoutes.HOME}><img alt={'singapore business award'} width={width} src={Logo} /></Link>
    </div>
  )
}

export default AppLogo;